import { render } from "./EditEndpointDialog.vue?vue&type=template&id=36f87114&scoped=true&ts=true"
import script from "./EditEndpointDialog.ts?vue&type=script&lang=ts"
export * from "./EditEndpointDialog.ts?vue&type=script&lang=ts"

import "./EditEndpointDialog.vue?vue&type=style&index=0&id=36f87114&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f87114"]])

export default __exports__